// src/stores/UsageStore.js
// UsageStore — read-only, tenant-admin-facing state for /admin/entitlements/usage.
// One focused store (mirrors UsersStore.js's scope and fetch/unwrap mechanics —
// same {status, content} envelope handling as EntitlementsStore.load()).
import { makeAutoObservable, runInAction } from "mobx";

import { fetchUsageSeries } from "../queries/usage";

class UsageStore {
  series = [];
  loading = false;
  error = null;
  lastFetchedAt = null;

  constructor(rootStore) {
    this.root = rootStore;
    makeAutoObservable(this, { root: false });
  }

  get authData() {
    return this.root?.userStore?.authData;
  }

  async load() {
    if (!this.authData) return;
    this.loading = true;
    this.error = null;
    try {
      const resp = await fetchUsageSeries(this.authData);
      const items = resp?.content?.series ?? resp?.series ?? [];
      runInAction(() => {
        this.series = items;
        this.lastFetchedAt = new Date();
        this.loading = false;
      });
    } catch (err) {
      console.error("UsageStore.load failed", err);
      runInAction(() => {
        this.error = err.message || String(err);
        this.loading = false;
      });
    }
  }
}

export default UsageStore;
